import React from "react";

import { FallbackWrapper } from "./styles";

const Fallback = () => {
  return <FallbackWrapper />;
};

export default Fallback;
